<template>
  <modal
    ref="addCompany"
    :ok-disabled="loading"
    :ok-title="!edit ? 'Pridať' : 'Upraviť'"
    :title="!edit ? 'Nová spoločnosť' : 'Upraviť spoločnosť'"
    cancel-title="Zrušiť"
    full-height
    name="add-company"
    scrollable
    size="lg"
    type="from-right"
    @hidden="Object.assign($data, $options.data())"
    @ok="saveCompany"
    @show="fetchData"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading" ref="scroll" v-bar>
          <div>
            <b-row>
              <b-col md="6">
                <h4 class="mb-3">Údaje o spoločnosti</h4>
                <b-form-group label="Názov spoločnosti" label-for="name">
                  <b-form-input
                    v-model="form.name"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has('name') }"
                    data-vv-as="Názov spoločnosti"
                    name="name"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.first('name') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="IČO" label-for="regNumber">
                  <b-form-input v-model="form.regNumber" name="regNumber" />
                </b-form-group>
                <b-form-group label="DIČ" label-for="taxNumber">
                  <b-form-input v-model="form.taxNumber" name="taxNumber" />
                </b-form-group>
                <b-form-group label="IČ DPH" label-for="taxRegNumber">
                  <b-form-input
                    v-model="form.taxRegNumber"
                    name="taxRegNumber"
                  />
                </b-form-group>
                <b-form-group label="Oprávnená osoba" label-for="owner">
                  <b-form-input v-model="form.owner" name="owner" />
                </b-form-group>
                <b-form-group label="Email" label-for="email">
                  <b-form-input
                    v-model="form.email"
                    v-validate="'email'"
                    :class="{ 'is-invalid': errors.has('email') }"
                    data-vv-as="Email"
                    name="email"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.first('email') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Telefón" label-for="phone">
                  <b-form-input v-model="form.phone" name="phone" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <h4 class="mb-3">Adresa</h4>
                <b-form-group label="Ulica" label-for="street">
                  <b-form-input
                    v-model="form.street"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has('street') }"
                    data-vv-as="Ulica"
                    name="street"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.first('street') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Číslo" label-for="streetNumber">
                  <b-form-input
                    v-model="form.streetNumber"
                    v-validate="'required|numeric'"
                    :class="{ 'is-invalid': errors.has('streetNumber') }"
                    data-vv-as="Číslo"
                    name="streetNumber"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.first('streetNumber') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Súp. číslo" label-for="streetRegNumber">
                  <b-form-input
                    v-model="form.streetRegNumber"
                    name="streetRegNumber"
                  />
                </b-form-group>
                <b-form-group label="Mesto" label-for="city">
                  <b-form-input
                    v-model="form.city"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has('city') }"
                    data-vv-as="Mesto"
                    name="city"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.first('city') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="PSČ" label-for="postCode">
                  <b-form-input v-model="form.postCode" name="postCode" />
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </transition>
    </b-overlay>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'
export default {
  components: {
    Modal,
  },
  data() {
    return {
      loading: false,
      edit: false,
      form: {},
    }
  },
  methods: {
    fetchData() {
      if (this.edit) {
        this.loading = true
        this.$api.get(`companies/${this.form.id}`).then((res) => {
          this.form = res.data
          this.loading = false
        })
      }
    },
    saveCompany(e) {
      e.preventDefault()
      this.$validator.validateAll().then(() => {
        if (!this.errors.any() && !this.loading) {
          this.$api
            .post(this.edit ? 'companies/edit' : 'companies/add', this.form)
            .then((res) => {
              this.$swal({
                type: 'success',
                position: 'top',
                showCloseButton: true,
                text: res.data.success,
                timer: 5000,
              })
              this.$root.$emit('modal-hide', 'add-company')
              this.$root.$emit('reloadCompanyData')
            })
        } else {
          this.$swal({
            type: 'warning',
            position: 'top',
            showCloseButton: true,
            text: 'Formulár nieje správne vyplnený',
            timer: 5000,
          })
        }
      })
    },
  },
}
</script>
